"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const definables_1 = __importDefault(require("../maps/definables"));
const getDefinables_1 = __importDefault(require("../functions/definables/getDefinables"));
const validSlugCharacters_1 = __importDefault(require("../constants/validSlugCharacters"));
class Definable {
    constructor(slug) {
        this._slug = slug;
        if (this._slug.split("").some((character) => character !== "/" && validSlugCharacters_1.default.includes(character) === false)) {
            throw new Error(`${this.constructor.name} "${this._slug}" has an invalid slug.`);
        }
        if (definables_1.default.has(this.constructor.name) === false) {
            definables_1.default.set(this.constructor.name, new Map);
        }
        const list = (0, getDefinables_1.default)(this.constructor.name);
        if (list.has(this._slug)) {
            throw new Error(`${this.constructor.name} "${this._slug}" already exists.`);
        }
        list.set(this._slug, this);
    }
    get slug() {
        return this._slug;
    }
    getDefinableReference() {
        return {
            className: this.constructor.name,
            slug: this._slug
        };
    }
    delete() {
        (0, getDefinables_1.default)(this.constructor.name).delete(this._slug);
    }
    getAccessorErrorMessage(property) {
        return `Could not access ${this.constructor.name} "${this._slug}" ${property}.`;
    }
}
exports.default = Definable;
